import { get, some } from 'lodash'
import { required } from 'utils/validation'

function hasProjectSelected(projects) {
  const hasNone = !some(projects)

  return (
    hasNone && {
        text: 'At least one project should be selected',
        intlKey: 'errors.atLeastOne'

    }
  )
}

export default function(values) {
  return {
    language: required(get(values, 'language')),
    project: hasProjectSelected(get(values, 'project'))
  }
}
